module.exports = __webpack_public_path__ + "img/login-weixin.32eead09.png";